// extracted by mini-css-extract-plugin
module.exports = {"title":"CmsPage-title_41d04a91","body":"CmsPage-body_fb0f9e4b","container":"CmsPage-container_19c6d9b5","content":"CmsPage-content_05695542"};